export enum EnumTipoPosicion {
  Compra = 17,
  Venta = 18,
  Multiposition = 99
}
